var exports = {
  "k": "x43aef4ae--de6207--container",
};

module.exports = exports;
